/* eslint-disable react-hooks/exhaustive-deps */
import { Col, Form, Input, Row, Image, Popconfirm, Typography, Button, Tooltip, message, Spin, Modal } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import Dragger from "antd/lib/upload/Dragger";
import { InboxOutlined, CloseCircleOutlined, PlusCircleFilled, ExclamationCircleOutlined } from "@ant-design/icons";
import imageCompression from "browser-image-compression";
import { useMediaQuery } from "react-responsive";
// import { getPreSignedUrls, uploadFileToS3 } from "../utils/ExtraFunctions";
import { getPreSignedUrls, uploadFileToS3 } from "../../OfferTable/utils/helper";
import { getInitiatingAgentDetails } from "../features/helperFunctions";
import { contractStoreHandle } from "../../ContractStore/state/actions";
import { FiRefreshCw } from "react-icons/fi";
import { contractDataHandle } from "../state/actions";
import { contractNavInitialState } from "../../Common/commondata/commonData";
const { TextArea } = Input;
const { Text } = Typography;

const uploadImagesToS3 = async (imageBuffers, setLoading, contractAuthKey) => {
  try {
    setLoading(true);
    if (!imageBuffers || imageBuffers.length === 0) {
      message.error("No files to upload.");
      return null;
    }

    const filenames = imageBuffers.map((fileData) => fileData?.name);
    const preSignedUrls = await getPreSignedUrls({ filenames, accessToken: contractAuthKey, type: "BROKERAGE" });

    if (!preSignedUrls || preSignedUrls.length === 0) {
      message.error("No valid files to upload.");
      return null;
    }

    for (const fileData of imageBuffers) {
      const { url: uploadUrl } = preSignedUrls.find((item) => item?.fileName === fileData?.name) || {};

      if (!uploadUrl) {
        message.error(`URL not found for file: ${fileData?.name}`);
        continue;
      }

      const finalFileLink = await uploadFileToS3(fileData, uploadUrl);
      return finalFileLink;
    }
  } catch (error) {
    message.error("An unexpected error occurred during upload.");
    return null;
  } finally {
    setLoading(false);
  }
};
async function compressImage(file) {
  const maxSizeMB = 3;
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
  if (file.size <= maxSizeBytes) {
    return file;
  }

  const initialQuality = 0.7;
  let currentQuality = initialQuality;

  while (true) {
    try {
      const compressedFile = await imageCompression(file, { quality: currentQuality });
      if (compressedFile.size <= maxSizeBytes || currentQuality <= 0.1) {
        return compressedFile;
      }
      currentQuality -= 0.1;
    } catch (error) {
      throw error;
    }
  }
}
const editBrokerageIntialState = {
  formChange: false,
  isLogoDeleted: false,
  initialValues: {},
};
const EditBrokerageDetails = ({ currentUrlId, rootDocData, modalState, setModalState, contractAuthKey }) => {
  const isMobile = useMediaQuery({ maxWidth: 575 });
  const [brokerageForm] = Form.useForm();
  const dispatch = useDispatch();
  const imageFormdataRef = useRef([]);
  const [bufferData, setbufferData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editBrokerageState, setEditBrokerageState] = useState({ ...editBrokerageIntialState });

  const { initialValues, formChange, isLogoDeleted, syncDetails } = editBrokerageState;

  const { agentDetailsData, agentDetailsLoading } = useSelector((state) => state.createOffer);

  useEffect(() => {
    if (modalState?.editBrokerageModal) {
      const localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
      let agentData = syncDetails && agentDetailsData && Object.keys(agentDetailsData).length > 0 ? agentDetailsData : getInitiatingAgentDetails({ localData, rootDocData });
      const { officeDetails: { officeLogo } = {} } = localData || {};
      const logo = agentData?.brokerageLogo  || officeLogo || "";
      const initialValues = {
        firmName: agentData?.firmName || "",
        fullName: agentData?.fullName || "",
        email: agentData?.email || "",
        phoneNumber: agentData?.phoneNumber || "",
        faxNumber: agentData?.faxNumber || "",
        address: agentData?.address || "",
        officeLogo: logo,
        team: agentData?.team || "",
      };

      brokerageForm.setFieldsValue(initialValues);

      setEditBrokerageState((prev) => ({
        ...prev,
        initialValues,
        formChange: !!syncDetails,
        isLogoDeleted: false,
      }));

      // Reseting logo preview buffer if logo changed
      if (logo) {
        setbufferData([]);
        imageFormdataRef.current = [];
      }
    }
  }, [modalState?.editBrokerageModal, currentUrlId, agentDetailsData]);

  const onValuesChange = () => {
    const isChanged = checkForFormChanges();
    setEditBrokerageState((prev)=> ({ ...prev , formChange: isChanged }));
  };

  const checkForFormChanges = () => {
    const formValues = brokerageForm.getFieldsValue();
    const isChanged = Object.keys(initialValues)?.length === 0 ? Object.values(formValues)?.some((value) => value) : Object.keys(initialValues)?.some((key) => initialValues[key] !== formValues[key]);
    return isChanged;
  };

  function bytesToSize(bytes) {
    let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  }

  function beforeUpload(file) {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJpgOrPng) {
      throw new Error("You can only upload JPG/PNG file!");
    }
    return isJpgOrPng;
  }

  function deleteImg(index) {
    let filterData = bufferData.filter((el, i) => i !== index);
    setbufferData(filterData);
    const imageFormdataCopy = [...imageFormdataRef.current];
    imageFormdataCopy.splice(index, 1);
    imageFormdataRef.current = imageFormdataCopy;
  }

  let handleCustome = async (data) => {
    const image = await compressImage(data.file);
    const reader = new FileReader();

    reader.readAsDataURL(image);
    reader.onload = () => {
      const newFile = {
        name: data.file.name,
        size: bytesToSize(image.size),
        file: reader.result,
        origin: "base64",
      };
      setbufferData((prevFiles) => {
        if (prevFiles.length) {
          return [...prevFiles, newFile];
        } else {
          return [newFile];
        }
      });
      imageFormdataRef.current = [...imageFormdataRef.current, image];
    };
    reader.onerror = (error) => {
      return error;
    };
  };

  let handleFilesSelected = (event) => {
    const selectedFiles = Array.from(event.target.files);
    selectedFiles.forEach(async (file) => {
      const image = await compressImage(file);
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = () => {
        const newFile = {
          name: file.name,
          size: bytesToSize(image.size),
          file: reader.result,
          origin: "base64",
        };
        setbufferData((prevFiles) => [...prevFiles, newFile]);
        imageFormdataRef.current = [...imageFormdataRef.current, image];
      };
      reader.onerror = (error) => {
        return error;
      };
    });
  };
  let handleAddFile = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.multiple = true;
    input.addEventListener("change", handleFilesSelected);
    input.click();
  };

  useEffect(() => {
    if (bufferData?.length < 1) {
      const handlePasteEvent = async (event) => {
        let count = 0;
        const items = (event.clipboardData || event.originalEvent.clipboardData).items;

        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          if (item.kind === "file" && count === 0) {
            const blob = item.getAsFile();
            const ide = Math.floor(10000 + Math.random() * 90000);
            const imageName = "pastedImage" + ide;
            const updatedBlob = new File([blob], imageName, { type: blob.type });
            const image = await compressImage(updatedBlob);
            const checkImage = beforeUpload(updatedBlob);

            if (checkImage) {
              await processImage(image, updatedBlob);
              count += 1;
            }
          }
        }
      };

      const processImage = (image, updatedBlob) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => {
            const newFile = {
              name: updatedBlob.name,
              size: bytesToSize(image.size),
              file: reader.result,
              origin: "base64",
            };

            setbufferData((prevFiles) => {
              return prevFiles.length ? [...prevFiles, newFile] : [newFile];
            });

            imageFormdataRef.current = [...imageFormdataRef.current, image];
            resolve();
          };
          reader.readAsDataURL(image);
        });
      };

      document.addEventListener("paste", handlePasteEvent);
      return () => {
        document.removeEventListener("paste", handlePasteEvent);
      };
    } else {
      setEditBrokerageState({ ...editBrokerageState, formChange: true });
    }
  }, [bufferData]);

  const handleEditBrokerageModalOk = async () => {
    try {
      const values = await brokerageForm.validateFields();
      setLoading(true);
      const localData = JSON.parse(localStorage.getItem(currentUrlId)) || {};
      localData.officeDetails = localData.officeDetails || {};
      if (syncDetails) {
        localData.officeDetails = {
          agentId: rootDocData?.builtForId,
          name: values.firmName,
          officeLogo: values.officeLogo,
          address: values.address,
        };
      }
       values.officeLogo = ""
      // Handle logo updates
      if (imageFormdataRef.current?.length > 0) {
        const finalFileLink = await uploadImagesToS3(imageFormdataRef.current, setLoading, contractAuthKey);
        values.officeLogo = finalFileLink;
        if (finalFileLink) {
          localData.officeDetails.officeLogo = finalFileLink;
        }
      } else if (isLogoDeleted) {
        localData.officeDetails = localData.officeDetails || {};
        localData.officeDetails.officeLogo = "";
        values.officeLogo = "";
      }
     
      const agentType = rootDocData?.RTDInitiator === "BUYER" ? "BuyerAgents" : "SellerAgents";
      const agents = localData[agentType] || [];
      const agentData = getInitiatingAgentDetails({ localData, rootDocData });
      const updatedAgents = agents.map((agent) => (agent.personId === agentData.personId ? { ...agent, ...values } : agent));

      localStorage.setItem(
        currentUrlId,
        JSON.stringify({
          ...localData,
          [agentType]: updatedAgents,
        })
      );

      dispatch(
        contractStoreHandle.autoSaveContract({
          currentUrlId,
          contractAuthKey,
          valueObj: {
            [agentType]: updatedAgents,
            officeDetails: localData.officeDetails,
          },
        })
      );
      handleEditBrokerageModalCancel();
      setTimeout(() => {
        message.success("Updated Successfully!");
      }, 0);
    } catch (error) {
      console.error("Submission failed", error);
      return;
    } finally {
      setLoading(false);
    }
  };

  const handleEditBrokerageModalCancel = () => {
    setEditBrokerageState({ ...editBrokerageIntialState });
    setbufferData([]);
    imageFormdataRef.current = [];
    brokerageForm?.resetFields();
    setModalState({ ...contractNavInitialState });
    dispatch(contractDataHandle.setAgentDetailsData({}));
  };
  const handleSyncBrokerageDetails = () => {
    Modal.confirm({
      title: `This will replace the current brokerage details with your account brokerage details. Are you sure you want to proceed?`,
      okText: "Yes",
      cancelText: "No",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        let query = {
          agentId: rootDocData.builtForId,
        };
        dispatch(contractDataHandle.getAgentDetails({ query, accessToken: contractAuthKey }));
        setEditBrokerageState((prev) => ({ ...prev, formChange: true, syncDetails: true }));
      },
      onCancel() {},
    });
  };

  return (
    <>
      {modalState?.editBrokerageModal && (
        <Modal
          title={
            <div className="commonModalTitle">
              Edit Brokerage Details
              <Tooltip title="Sync with your account brokerage details" placement="right">
                <FiRefreshCw style={{ cursor: "pointer", color: "blue", marginLeft: 20, fontWeight: "bold" }} onClick={handleSyncBrokerageDetails} />
              </Tooltip>
            </div>
          }
          visible={modalState?.editBrokerageModal}
          onCancel={handleEditBrokerageModalCancel}
          width={700}
          footer={
            <>
              <Button onClick={handleEditBrokerageModalCancel}>Cancel</Button>
              <Button type="primary" htmlType="submit" onClick={handleEditBrokerageModalOk} disabled={!formChange}>
                Done
              </Button>
            </>
          }
        >
          <div style={{ height: "50vh", padding: "0px 10px", overflow: "auto", marginTop: "-15px", marginBottom: "-20px" }}>
            {loading || agentDetailsLoading ? (
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
                <Spin size="large" />
              </div>
            ) : (
              <Form form={brokerageForm} onFinish={handleEditBrokerageModalOk} layout="vertical" style={{ padding: 10 }} scrollToFirstError onValuesChange={onValuesChange}>
                <Form.Item
                  name={`officeLogo`}
                  className="lbl1"
                  label={
                    <div style={{ display: "flex", gap: "15px" }}>
                      <div style={{ marginTop: "6px" }}>Logo</div>
                      {!bufferData?.length && (
                        <div>
                          <span
                            style={{
                              color: "#1990ff",
                              fontSize: "27px",
                              cursor: "pointer",
                              top: 0,
                            }}
                            onClick={handleAddFile}
                          >
                            <Tooltip title="Update Logo" trigger={["click", "hover"]}>
                              <PlusCircleFilled />
                            </Tooltip>
                          </span>{" "}
                        </div>
                      )}
                    </div>
                  }
                >
                  {bufferData.length > 0 ? (
                    <Form.Item>
                      <div
                        style={{
                          display: "flex",
                          maxWidth: "100%",
                          overflow: "auto",
                          minHeight: "120px",
                          boxShadow: "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                        }}
                      >
                        {bufferData.map((file, index) => (
                          <div key={index} style={{ margin: "10px", textAlign: "center" }}>
                            <Image
                              width={100}
                              src={file.file}
                              preview={{
                                visible: false,
                                mask: (
                                  <div
                                    style={{
                                      cursor: "pointer",
                                      position: "absolute",
                                      zIndex: 21,
                                      top: "0px",
                                      right: "0px",
                                    }}
                                  >
                                    <div
                                      onClick={(event) => {
                                        event.stopPropagation();
                                      }}
                                    >
                                      <Popconfirm
                                        title="Are you sure you want to delete this image?"
                                        onConfirm={() => {
                                          deleteImg(index);
                                        }}
                                        okText="Yes"
                                        cancelText="No"
                                      >
                                        <CloseCircleOutlined style={{ fontSize: "30px" }} />
                                      </Popconfirm>
                                    </div>
                                  </div>
                                ),
                              }}
                            />
                            <br />
                            <Text type="secondary">{file.name}</Text>
                            <br />
                            <Text type="secondary">Size: {file.size}</Text>
                          </div>
                        ))}
                      </div>
                    </Form.Item>
                  ) : initialValues.officeLogo && !isLogoDeleted ? (
                    <Form.Item>
                      <Image style={{ objectFit: "contain" }} width={"40%"} height={110} src={initialValues.officeLogo}></Image>
                      <Tooltip title="Remove brokerage logo">
                        <CloseCircleOutlined
                          style={{ position: "absolute", top: "4px", right: isMobile ? "40%" : "25%", fontSize: "24px", cursor: "pointer", color: "#178DFA" }}
                          onClick={() => {
                            setEditBrokerageState({ ...editBrokerageState, formChange: true, isLogoDeleted: true });
                          }}
                        />
                      </Tooltip>
                    </Form.Item>
                  ) : (
                    <Dragger accept="image/*" showUploadList={false} customRequest={handleCustome} maxCount={1}>
                      <div style={{ height: "150px" }}>
                        <p className="ant-upload-drag-icon">
                          <InboxOutlined style={{ position: "relative", top: "-5px" }} />
                        </p>
                        <p className="ant-upload-text" style={{ position: "relative", top: "-25px" }}>
                          Click or drag or paste file to this area to upload
                        </p>
                        <p className="ant-upload-hint" style={{ position: "relative", top: "-20px" }}>
                          Support for logo image upload. Strictly prohibit from uploading company data or other banned files
                        </p>
                      </div>
                    </Dragger>
                  )}
                </Form.Item>

                <Form.Item className="lbl1" name="fullName" label="Broker's Name" rules={[{ required: true, message: "Please enter broker's name!" }]} style={{ marginTop: "20px" }}>
                  <Input type="text" allowClear placeholder="Enter Broker's Name" />
                </Form.Item>

                <Form.Item className="lbl1" name="firmName" label="Brokerage Firm’s Name">
                  <Input type="text" allowClear placeholder="Enter Firm’s Name" />
                </Form.Item>

                <Form.Item className="lbl1" name="address" label="Address">
                  <TextArea type="text" placeholder="Enter Address" allowClear />
                </Form.Item>
                <Form.Item className="lbl1" name="phoneNumber" label="Phone No.">
                  <PhoneInput allowClear inputStyle={{ width: "100%" }} inputClass="phoneInput" country={"us"} onlyCountries={["us"]} maxLength="10" international={false} disableCountryCode={true} placeholder="Enter Mobile Number" className="phone-input" />
                </Form.Item>

                <Form.Item
                  className="lbl1"
                  name="email"
                  label="Email Address"
                  rules={[
                    {
                      type: "email",
                      message: "Not a valid Email!",
                    },
                    {
                      required: true,
                      message: "Please Enter Email!",
                    },
                    { whitespace: true },
                  ]}
                >
                  <Input type="text" allowClear placeholder="Enter Email" />
                </Form.Item>
                <Form.Item
                  className="lbl1"
                  name="team"
                  label="Team"
                  allowClear
                >
                  <Input type="text" allowClear placeholder="Enter Team Name" />
                </Form.Item>
              </Form>
            )}
          </div>
        </Modal>
      )}
    </>
  );
};

export default EditBrokerageDetails;
